import * as React from 'react';

import DisabledFeatures from 'ab-common/environment/disabledFeatures';

import { Button } from '@acceligentllc/storybook';

import UserGuideModal from 'af-components/UserGuideModal';

interface Props {
	visible: boolean;
	startGuideUri: string;
}

const UserGuideLegend: React.FC<Props> = (props) => {

	const { visible, startGuideUri } = props;

	const [isModalOpen, setIsModalOpen] = React.useState(false);

	const openModal = React.useCallback(() => {
		setIsModalOpen(true);
	}, []);

	const closeModal = React.useCallback(() => {
		setIsModalOpen(false);
	}, []);

	return (
		<>
			{(visible && !DisabledFeatures.UserGuide) ? (
				<>
					<Button
						icon="MarkQuestionOutline"
						label="User Guide"
						onClick={openModal}
						style="secondary"
					/>
					<UserGuideModal closeModal={closeModal} isModalOpen={isModalOpen} startGuideUri={startGuideUri} ></UserGuideModal>
				</>
			) : <></>}

		</>);
};

export default UserGuideLegend;
